import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";

import CustomRichTextEditor from "./CustomRichTextEditor";
import CustomMinimizablePopup from "./CustomMinimizablePopup";
import { useParams } from "react-router-dom";
import { addEmployeeNote, updateNote } from "@/services/employee.services";
import { toastMessage } from "@/utils/helper/myToast";
import { useAppDispatch } from "@/store/store";
import { resetNote } from "@/store/features/employeeSlice";
import { setPageEvent } from "@/store/features/dashboardSlice";

const AddAndEditNotePopup = ({
  isVisible,
  setIsVisible,
  onClose,
  noteData,
  heading,
  minimizedPopupHeading,
  primaryButtonDetails,
  secondaryButtonDetails,
}: any) => {
  const [noteContent, setNoteContent] = useState("");
  const [isNoteTouched, setIsNoteTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { employeeId } = useParams();
  const dispatch = useAppDispatch();

  const { fetchSingleNoteLoading, resetAddAndEditNotePopupFocus } = {
    fetchSingleNoteLoading: false,
    resetAddAndEditNotePopupFocus: false,
  };
  const closePopUp = () => {
    onClose();
    setNoteContent("");
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const res: any = noteData?.noteData
        ? await updateNote({ note: noteContent, empId: employeeId, noteId: noteData?.noteId, acTyp: "update" })
        : await addEmployeeNote({ note: noteContent, empId: employeeId });
      if (res?.status === 200) {
        const { message, isError, showMessage } = res.data;
        closePopUp();
        dispatch(setPageEvent({ keys: ["notes"], type: "refresh" }));
        setTimeout(() => {
          dispatch(setPageEvent(null));
        }, 5000);
        if (showMessage) toastMessage(message, isError);
      } else {
        const { message, isError } = res?.response?.data || {};
        if (message) toastMessage(message, isError);
      }
    } finally {
      setIsLoading(false);
      dispatch(resetNote());
    }
  };

  useEffect(() => {
    if (noteData) {
      setNoteContent(noteData.noteData);
    } else {
      setNoteContent("");
    }
  }, [noteData]);

  return (
    <CustomMinimizablePopup
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      heading={heading}
      minimizedPopupHeading={minimizedPopupHeading}
      onClose={closePopUp}
      primaryButtonText={primaryButtonDetails.text}
      secondaryButtontext={secondaryButtonDetails.text}
      handleClickPrimaryButton={handleSubmit}
      isPrimaryButtonDisable={!noteContent || isLoading || !isNoteTouched}
      handleClickSecondaryButton={secondaryButtonDetails?.handler}
      popupActionLoading={isLoading}
      isContentEdited={isNoteTouched}
      setIsContentEdited={setIsNoteTouched}
      loading={isLoading}
    >
      <CustomRichTextEditor
        richTextContent={noteContent}
        handleInputChange={(data: any) => {
          setNoteContent(data);
          setIsNoteTouched(true);
        }}
        isLoading={fetchSingleNoteLoading}
        resetFocus={resetAddAndEditNotePopupFocus}
      />
    </CustomMinimizablePopup>
  );
};

export default AddAndEditNotePopup;
